import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  input: string = '';

  constructor(
    private dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,

  ) {

   }

  ngOnInit(): void {
  }

  okButtonClicked(ok: Function) {
    if(ok !== undefined) {
      if(this.data.input) {
        ok(this.input);
      } else {
        ok();
      }
    }
    const result = {
      clicked: 'ok',
      input: this.input
    }
    this.close({clicked: 'ok'});
  }

  cancelButtonClicked(cancel: Function) {
    if(cancel !== undefined) cancel();
    this.close({clicked: 'cancel'});
  }

  close(result: any) {
    this.dialogRef.close(result);
  }
}

interface DialogData {
  title: string,
  message: string,
  okHandle: Function,
  cancelHandle: Function,
  input: boolean,
  /** 입력칸 라벨. 미지정 시 '목적'. */
  inputLabel?: string
}
